<template lang="pug">
    .container
        label.text-xs(:for="name") {{ label }}
        select(
            :name="name" 
            :id="name"
            class="text-xs h-10 w-full mt-1 pl-3 pr-3 caret-slate-300 border rounded border-slate-300 bg-white"
            @change="onSelect"
            v-model="selected"
        )
            template(v-for="(item, index) in options")
                option(:key="index" :selected="item.selected") {{ item.name }}
</template>

<script>
export default {
    name: "Select",
    props: {
        name: {
            type: String,
        },
        id: {
            type: String,
        },
        label: {
            type: String,
        },
        options: {
            type: Array,
            default: () => [],
        },
        predefined: {
            type: String,
        },
    },
    data() {
        return {
            selected: '',
        }
    },
    methods: {
        onSelect() {
            this.$emit('value', this.selected)
        },
    },
    watch: {
        predefined: {
            handler(val) {
                if (val)
                    this.selected = val
            },
            deep: true,
            immediate: true,
        },
    }
}
</script>

<style lang="scss">
select {
    outline: none !important;
}
</style>